import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Input from '@components/Forms/TextField';

import SubmitAndBack from '@components/Forms/SubmitAndBack';
import * as Routes from '@constants/routes';
import GenericForm from '@components/Forms/GenericForm';
import LoginHeader from '@components/LoginHeader';
import Card from '@components/Cards/ScreenCard';
import { cleanUsersByRut, getUsersByRut } from '@store/login/actions';

import Header from '@components/Forms/Header';
import useBreakpoint from '@hooks/breakpoint';
import { useHistory } from 'react-router';
import OperationLoguinTable from '@components/TableLoguin';
import { theme } from 'fpay-ui';

import { defaultDocumentType } from '@constants/regions';
import schema from './schema';

const Container = styled.div`
  ${({ theme }) => theme.breakpoint('sm', 'md')} {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
`;

const ContainerButton = styled.div`
  display: flex;
  max-width: 406px;
  justify-content: flex-end;
`;

const ContainerRecovery = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  ${({ theme }) => theme.breakpoint('sm', 'md')} {
    max-width: 406px;
  }
`;

const ContainerRecoveryAll = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
`;

const ButtonBack = styled.div`
  ${theme.textTypes['Body-2-w400']}
  text-align: center;
  width: 100%;
  max-width: 158px;
  line-height: 1.36;
  color: ${theme.colors.white};
  width: 100%;
  padding-top: 11px;
  padding-bottom: 10px;
  justify-content: center;
  margin-bottom: 16px;
  margin-top: 24px;
  border-radius: 4px;
  cursor: pointer;
  background-color: ${theme.colors.gbrand500};
  transition: all 0.3s ease 0s;
  &:hover {
    box-shadow: 0 1px 6px rgb(32 33 36 / 28%);
    background-color: ${theme.colors.gbrand600};
  }
  &:active {
    border: 0.5px solid ${theme.colors.gbrand500};
  }
  ${({ theme }) => theme.breakpoint('sm', 'md')} {
    max-width: 100%;
    padding-top: 14px;
    padding-bottom: 13px;
  }
`;

const UserRecovery = (props) => {
  const { recover_user: users, recover_error_user: error } = useSelector((state) => state.login);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();

  const { mobile } = useBreakpoint();

  const [rut, setRut] = useState();
  const [operationHeader] = useState(['NOMBRE', 'USUARIO / MAIL']);

  const handleSubmit = () => {
    dispatch(getUsersByRut(rut));
  };

  const handleBack = () => {
    dispatch(cleanUsersByRut);
    history.push(Routes.LOGIN);
  };

  return (
    <Container>
      {mobile ? <Header withoutTextMobile /> : <LoginHeader />}
      <Card width="484px" title={t('userRecovery.title')} subtitle={t('userRecovery.subtitle')}>
        {users ? (
          <ContainerRecoveryAll>
            <ContainerRecovery>
              <OperationLoguinTable
                dataHeader={operationHeader}
                dataBody={users}
                properity={[{}, {}]}
              />
              <ContainerButton>
                <ButtonBack onClick={handleBack}>{t('userRecovery.back')}</ButtonBack>
              </ContainerButton>
            </ContainerRecovery>
          </ContainerRecoveryAll>
        ) : (
          <GenericForm schema={schema} item container onSubmit={handleSubmit} xs={12}>
            <Input
              value={rut}
              label={t('common.docType')}
              onChange={(e) => setRut(e.target.value)}
              isRequired
              id="rut"
              testId="rut"
              fullWidth
              variant="outlined"
              autoComplete="off"
              gridProps={{ xs: 12, item: true }}
              type={defaultDocumentType}
              error={error}
            />
            <SubmitAndBack
              gridProps={{ xs: 12, item: true }}
              submitText={t('userRecovery.continue')}
              handleBack={handleBack}
              reset
              handleSubmit={handleSubmit}
            />
          </GenericForm>
        )}
      </Card>
    </Container>
  );
};

export default UserRecovery;
